import PendingAdjustmentTable from './PendingAdjustmentTable'

export default PendingAdjustmentTable
